import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://rss.vclbgent.be/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const authAPI = {
  login: (firstname, email) => 
    api.post('/auth/login', { firstname, email }),
  
  getUser: (userId) => 
    api.get(`/user/${userId}`)
};

export const feedsAPI = {
  getFeeds: (userId) => 
    api.get(`/feeds/${userId}`),
  
  addFeed: (userId, url) => 
    api.post('/feeds', { userId, url }),
  
  deleteFeed: (feedId) => 
    api.delete(`/feeds/${feedId}`)
};

export const keywordsAPI = {
  getKeywords: (userId) => 
    api.get(`/keywords/${userId}`),
  
  addKeyword: (userId, keyword) => 
    api.post('/keywords', { userId, keyword }),
  
  deleteKeyword: (keywordId) => 
    api.delete(`/keywords/${keywordId}`)
};

export const articlesAPI = {
  getSentArticles: (userId, limit = 50) => 
    api.get(`/sent-articles/${userId}?limit=${limit}`),
  
  triggerFeedCheck: () => 
    api.post('/check-feeds')
};

export default api;
